var _style, _defs, _defs2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlaystation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{clip-path:url(#SVGID_4_);fill:#83858C;}\n\t.st3{fill:none;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M22.88,16.32c-0.43,0.55-1.49,0.94-1.49,0.94l-7.89,2.83V18l5.8-2.07c0.66-0.24,0.76-0.57,0.22-0.74 c-0.53-0.18-1.5-0.13-2.16,0.11l-3.87,1.36v-2.17l0.22-0.08c0,0,1.12-0.4,2.69-0.57c1.57-0.17,3.5,0.02,5.01,0.6 C23.12,14.98,23.31,15.77,22.88,16.32z M14.25,12.76V7.42c0-0.63-0.12-1.21-0.7-1.37c-0.45-0.14-0.73,0.27-0.73,0.9v13.38 l-3.61-1.15V3.23c1.53,0.28,3.77,0.96,4.97,1.36c3.06,1.05,4.09,2.36,4.09,5.3C18.27,12.76,16.5,13.85,14.25,12.76z M2.59,17.78 c-1.75-0.49-2.04-1.52-1.24-2.11c0.74-0.55,1.99-0.96,1.99-0.96l5.17-1.84v2.1L4.78,16.3c-0.66,0.24-0.76,0.57-0.22,0.75 c0.53,0.18,1.5,0.13,2.16-0.11l1.79-0.65v1.88c-0.11,0.02-0.24,0.04-0.36,0.06C6.36,18.52,4.46,18.4,2.59,17.78z M21.73,18.61 c0.23,0,0.44,0.09,0.6,0.25c0.16,0.16,0.25,0.37,0.25,0.6c0,0.23-0.09,0.44-0.25,0.6c-0.16,0.16-0.37,0.25-0.6,0.25 c-0.23,0-0.44-0.09-0.6-0.25c-0.16-0.16-0.25-0.37-0.25-0.6C20.89,18.99,21.26,18.61,21.73,18.61z M21.03,19.45 c0,0.19,0.07,0.36,0.21,0.5c0.13,0.13,0.31,0.21,0.5,0.21c0.39,0,0.7-0.32,0.7-0.7c0-0.19-0.07-0.36-0.21-0.5 c-0.13-0.13-0.31-0.21-0.5-0.21c-0.19,0-0.36,0.07-0.5,0.21C21.1,19.09,21.03,19.27,21.03,19.45z M21.99,19 c0.09,0.04,0.14,0.12,0.14,0.23c0,0.06-0.01,0.11-0.04,0.14c-0.02,0.03-0.04,0.05-0.07,0.07c0.02,0.01,0.04,0.03,0.06,0.05 c0.02,0.03,0.03,0.07,0.03,0.12l0,0.12c0,0.03,0,0.06,0.01,0.07c0.01,0.02,0.01,0.04,0.03,0.04l0.01,0.01v0.01v0.02v0.02h-0.02 h-0.15h-0.01l-0.01-0.01c-0.01-0.01-0.01-0.02-0.01-0.04c0-0.01-0.01-0.04-0.01-0.07l-0.01-0.15c0-0.05-0.02-0.08-0.05-0.1 c-0.02-0.01-0.05-0.01-0.1-0.01h-0.26v0.36v0.02h-0.02h-0.12h-0.02v-0.02v-0.9v-0.02h0.02h0.42C21.88,18.97,21.94,18.98,21.99,19 z M21.53,19.38h0.26c0.05,0,0.09-0.01,0.12-0.03c0.03-0.02,0.04-0.06,0.04-0.11c0-0.06-0.02-0.09-0.06-0.11 c-0.02-0.01-0.05-0.02-0.09-0.02h-0.28V19.38z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 0.92,
    y: 3.23,
    width: 22.15,
    height: 17.54
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -3.69,
    y: -1.38,
    className: "st2",
    width: 31.38,
    height: 26.33
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3.23,
    className: "st3",
    width: 24,
    height: 17.54
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaystation);
export default __webpack_public_path__ + "static/media/icon-playstation.ba9889dfd8b59206fb592cb6e0df8faf.svg";
export { ForwardRef as ReactComponent };